const products = JSON.parse(document.querySelector('[data-section-data]').innerHTML);
console.log(products)

const helpSideBar = document.getElementById('HelpDrawer');
const header = helpSideBar.querySelector('.drawer__title');
const infoText = helpSideBar.querySelector('.text-base');
const helpList = helpSideBar.querySelector('.help-list');
const helpMe = document.querySelector('.model__wrapper a');
const imageId = 'modelImage'

async function fetchProductDetails(product) {
    // Replace with the actual URL to fetch product details
    const response = await fetch(window.Shopify.routes.root + `products/${product}.js`);
    if (response.ok) {
        return await response.json();
    } else {
        throw new Error("Failed to fetch product details");
    }
}

function searchProductByModel(modelNumber) {
    for (const productKeys in products) {
        if (products[productKeys].includes(modelNumber)) {
            return productKeys.split(','); // Split the keys into an array
        }
    }
    return null;
}

helpMe.addEventListener("click", function() {
    header.textContent = 'Find Your Model';
    infoText.textContent = 'Please refer to the following image. This is located on the bottom or backside of the unit.'
    helpList.style.display = 'none';

    if (!document.getElementById(imageId)) {
        const img = document.createElement('img');
        img.id = imageId; // Set the unique ID for the image
        img.src = 'https://cdn.shopify.com/s/files/1/0484/2428/8407/files/NewDataPlate-SKU3.png?v=1611781291';
        img.alt = 'Model Number'; // Optional alt text
        infoText.appendChild(img);
    } else {
        img.style.display = 'block';
    }
})

document.getElementById("find-my-part").addEventListener("input", function(event) {
    const inputField = document.getElementById("find-my-part");
    const searchButton = document.getElementById("search-button");
    
    if (inputField.value.trim() !== "") {
        searchButton.classList.remove("disabled");
        searchButton.disabled = false;
    } else {
        searchButton.classList.add("disabled");
        searchButton.disabled = true;
    }
});

document.getElementById('find-my-part').addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
        event.preventDefault(); // Prevent default Enter key behavior (form submission)
        const searchButton = document.getElementById("search-button");
        searchButton.click(); // Trigger click event on search button
    }
});

document.getElementById("search-button").addEventListener("click", async function() {
    const modelNumber = document.getElementById("find-my-part").value.trim().toUpperCase().replace(/[- ]/g, '');
    const productKeys = searchProductByModel(modelNumber);

    if (productKeys) {
        let productFound = false;
        for (const product of productKeys) {
            try {
                const randomNum = Math.floor(Math.random() * 1000000000);
                const productData = await fetchProductDetails(product);
                // partModal.show();

                const eventLabel = "Found - " + modelNumber;
                
                // Track search event in Google Analytics
                gtag('event', 'part_search', {
                    'search_term': modelNumber,
                    'product_found': product,
                    'event_label': eventLabel
                });

                window.location.href = `/pages/product-help?product=${productData.handle}&sku=${modelNumber}&type=${randomNum}`;

                productFound = true;
                break;  // Exit the loop if a product is successfully fetched
            } catch (error) {
                console.error(error.message);
            }
        }

        if (!productFound) {
            header.textContent = "Product not found";
            infoText.textContent = "Please make sure you've entered your model correctly. If you have, then please contact us using one of the methods below and we will be happy to assist!";
            helpList.style.display = 'grid';
            document.getElementById('modelImage').style.display = 'none';

            helpSideBar.show();
        }
    } else {
        header.textContent = "Product not found";
        infoText.textContent = "Please make sure you've entered your model correctly. If you have, then please contact us using one of the methods below and we will be happy to assist!";
        helpList.style.display = 'grid';
        if (document.getElementById('modelImage')) {
            document.getElementById('modelImage').style.display = 'none';
        }

        helpSideBar.show();
        
        const eventLabel = "Not Found - " + modelNumber;

        // Track unsuccessful search event in Google Analytics
        gtag('event', 'part_search', {
            'search_term': modelNumber,
            'event_label': eventLabel
        });
    }
});
document.addEventListener("DOMContentLoaded", function() {
    const searchInput = document.getElementById("find-my-part");

    // Function to clear search input value
    function clearSearchInput() {
        searchInput.value = "";
    }

    // Clear search input value on page load and when navigating back to the page
    window.addEventListener("pageshow", clearSearchInput);
    clearSearchInput(); // Ensure it's also cleared on initial load

});






